const COUNTRY_DIAL_CODES = {
  AD: '+376',
  AE: '+971',
  AF: '+93',
  AG: '+1',
  AI: '+1',
  AL: '+355',
  AM: '+374',
  AO: '+244',
  AR: '+54',
  AS: '+1',
  AT: '+43',
  AU: '+61',
  AW: '+297',
  AZ: '+994',
  BA: '+387',
  BB: '+1',
  BD: '+880',
  BE: '+32',
  BF: '+226',
  BG: '+359',
  BH: '+973',
  BI: '+257',
  BJ: '+229',
  BM: '+1',
  BN: '+673',
  BO: '+591',
  BR: '+55',
  BS: '+1',
  BT: '+975',
  BW: '+267',
  BY: '+375',
  BZ: '+501',
  CA: '+1',
  CD: '+243',
  CF: '+236',
  CG: '+242',
  CH: '+41',
  CI: '+225',
  CK: '+682',
  CL: '+56',
  CM: '+237',
  CN: '+86',
  CO: '+57',
  CR: '+506',
  CU: '+53',
  CV: '+238',
  CY: '+357',
  CZ: '+420',
  DE: '+49',
  DJ: '+253',
  DK: '+45',
  DM: '+1',
  DO: '+1',
  DZ: '+213',
  EC: '+593',
  EE: '+372',
  EG: '+20',
  ER: '+291',
  ES: '+34',
  ET: '+251',
  FI: '+358',
  FJ: '+679',
  FR: '+33',
  GA: '+241',
  GB: '+44',
  GD: '+1',
  GE: '+995',
  GH: '+233',
  GM: '+220',
  GN: '+224',
  GQ: '+240',
  GR: '+30',
  GT: '+502',
  GU: '+1',
  GW: '+245',
  GY: '+592',
  HK: '+852',
  HN: '+504',
  HR: '+385',
  HT: '+509',
  HU: '+36',
  ID: '+62',
  IE: '+353',
  IL: '+972',
  IN: '+91',
  IQ: '+964',
  IR: '+98',
  IS: '+354',
  IT: '+39',
  JM: '+1',
  JO: '+962',
  JP: '+81',
  KE: '+254',
  KG: '+996',
  KH: '+855',
  KM: '+269',
  KN: '+1',
  KR: '+82',
  KW: '+965',
  KZ: '+7',
  LA: '+856',
  LB: '+961',
  LC: '+1',
  LI: '+423',
  LK: '+94',
  LR: '+231',
  LS: '+266',
  LT: '+370',
  LU: '+352',
  LV: '+371',
  LY: '+218',
  MA: '+212',
  MC: '+377',
  MD: '+373',
  ME: '+382',
  MG: '+261',
  ML: '+223',
  MM: '+95',
  MN: '+976',
  MO: '+853',
  MR: '+222',
  MS: '+1',
  MT: '+356',
  MU: '+230',
  MV: '+960',
  MW: '+265',
  MX: '+52',
  MY: '+60',
  MZ: '+258',
  NA: '+264',
  NE: '+227',
  NG: '+234',
  NI: '+505',
  NL: '+31',
  NO: '+47',
  NP: '+977',
  NZ: '+64',
  OM: '+968',
  PA: '+507',
  PE: '+51',
  PG: '+675',
  PH: '+63',
  PK: '+92',
  PL: '+48',
  PR: '+1',
  PT: '+351',
  PY: '+595',
  QA: '+974',
  RO: '+40',
  RS: '+381',
  RU: '+7',
  RW: '+250',
  SA: '+966',
  SC: '+248',
  SD: '+249',
  SE: '+46',
  SG: '+65',
  SI: '+386',
  SK: '+421',
  SL: '+232',
  SN: '+221',
  SO: '+252',
  SR: '+597',
  SS: '+211',
  ST: '+239',
  SV: '+503',
  SY: '+963',
  SZ: '+268',
  TD: '+235',
  TG: '+228',
  TH: '+66',
  TN: '+216',
  TR: '+90',
  TT: '+1',
  TW: '+886',
  TZ: '+255',
  UA: '+380',
  UG: '+256',
  US: '+1',
  UY: '+598',
  UZ: '+998',
  VC: '+1',
  VE: '+58',
  VG: '+1',
  VI: '+1',
  VN: '+84',
  YE: '+967',
  ZA: '+27',
  ZM: '+260',
  ZW: '+263',
};

const TIMEZONE_COUNTRY_OVERRIDES = {
  'Africa/Abidjan': 'CI',
  'Africa/Accra': 'GH',
  'Africa/Addis_Ababa': 'ET',
  'Africa/Algiers': 'DZ',
  'Africa/Bamako': 'ML',
  'Africa/Bangui': 'CF',
  'Africa/Banjul': 'GM',
  'Africa/Bissau': 'GW',
  'Africa/Brazzaville': 'CG',
  'Africa/Cairo': 'EG',
  'Africa/Casablanca': 'MA',
  'Africa/Conakry': 'GN',
  'Africa/Dakar': 'SN',
  'Africa/Dar_es_Salaam': 'TZ',
  'Africa/Djibouti': 'DJ',
  'Africa/Douala': 'CM',
  'Africa/Harare': 'ZW',
  'Africa/Johannesburg': 'ZA',
  'Africa/Kampala': 'UG',
  'Africa/Kigali': 'RW',
  'Africa/Kinshasa': 'CD',
  'Africa/Lagos': 'NG',
  'Africa/Libreville': 'GA',
  'Africa/Lome': 'TG',
  'Africa/Luanda': 'AO',
  'Africa/Lubumbashi': 'CD',
  'Africa/Malabo': 'GQ',
  'Africa/Maputo': 'MZ',
  'Africa/Monrovia': 'LR',
  'Africa/Nairobi': 'KE',
  'Africa/Ndjamena': 'TD',
  'Africa/Niamey': 'NE',
  'Africa/Nouakchott': 'MR',
  'Africa/Ouagadougou': 'BF',
  'Africa/Porto-Novo': 'BJ',
  'Africa/Tunis': 'TN',
  'America/New_York': 'US',
  'America/Toronto': 'CA',
  'Asia/Dubai': 'AE',
  'Europe/Brussels': 'BE',
  'Europe/London': 'GB',
  'Europe/Paris': 'FR',
};

const STORAGE_KEY = 'liwaza_phone_country_default';

const normalizeCountryCode = (value) => {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().toUpperCase();
  return /^[A-Z]{2}$/.test(normalized) ? normalized : null;
};

const supportedCountryCode = (value) => {
  const countryCode = normalizeCountryCode(value);
  return countryCode && COUNTRY_DIAL_CODES[countryCode] ? countryCode : null;
};

const countryFromLocale = () => {
  if (typeof navigator === 'undefined') return null;
  const locales = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];

  for (const locale of locales) {
    try {
      const region = new Intl.Locale(locale).region;
      const countryCode = supportedCountryCode(region);
      if (countryCode) return countryCode;
    } catch {
      const match = locale?.match(/[-_]([A-Za-z]{2})$/);
      const countryCode = supportedCountryCode(match?.[1]);
      if (countryCode) return countryCode;
    }
  }

  return null;
};

const countryFromTimezone = () => {
  if (typeof Intl === 'undefined') return null;
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return supportedCountryCode(TIMEZONE_COUNTRY_OVERRIDES[timezone]);
  } catch {
    return null;
  }
};

const countryFromIp = async () => {
  if (typeof fetch === 'undefined') return null;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 2500);

  try {
    const response = await fetch('https://api.country.is/', {
      signal: controller.signal,
    });
    if (!response.ok) return null;

    const payload = await response.json();
    return normalizeCountryCode(payload?.country);
  } catch {
    return null;
  } finally {
    clearTimeout(timeoutId);
  }
};

const readCachedDefault = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const cached = raw ? JSON.parse(raw) : null;
    if (!cached || Date.now() - cached.timestamp > 24 * 60 * 60 * 1000) {
      return null;
    }
    return cached;
  } catch {
    return null;
  }
};

const writeCachedDefault = (value) => {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...value, timestamp: Date.now() })
    );
  } catch {
    // Storage can be unavailable in private browsing.
  }
};

export const getPhoneCountryDefault = async () => {
  const cached = readCachedDefault();
  if (cached?.dialCode) return cached;

  const detectedCountry =
    supportedCountryCode(await countryFromIp()) ||
    countryFromTimezone() ||
    countryFromLocale();
  const countryCode = detectedCountry || 'FR';
  const dialCode = COUNTRY_DIAL_CODES[countryCode] || '+33';
  const result = { countryCode, dialCode };
  writeCachedDefault(result);
  return result;
};

export const buildPhoneDialCodePrefix = ({ dialCode } = {}) =>
  dialCode ? `${dialCode} ` : '';

